const Forecasts = () => {

    return (
        <>
            <div className="market-info__content-title-container">
                <div className="market-info__content-title">Prognoosid</div>
            </div>
            <div style={{ fontStyle: 'italic', paddingTop: '10px' }}>
                Kuu prognoosid. Vaja ehitada backend'i endpoint, kuhu tekst laadida. Praegu võime lisada manuaalselt pilte.
            </div>
            <div style={{overflowX: 'auto', padding: '10px 0px'}}>
                <img style={{maxWidth: '800px'}}
                    src={"images/png/forecast-2025-dec.png"}
                    alt="forecast-2025-dec"
                />
            </div>
        </>
    );
}

export default Forecasts;